<template>
    <app-content-admin>
        <template slot="header">View Subscriber Details</template>
               
        <v-layout row wrap>

<v-flex xs12 lg6 mx-auto>
    <v-card>
        <v-card-text>           
            <v-container fluid grid-list-xs>
                <v-layout wrap>

                    <v-flex xs12>
                        <v-select
                            :items="project_list"
                            :item-text="'project_name'"
                            :item-value="'project_id'"
                            :label="$t('Project')"
                            v-model="form.id_project"
                            :rules="[rules.required('Project')]"
                            outlined
                           :disabled="true"
                        ></v-select>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field
                            :label="$t('First Name')"
                            v-model="form.firstname"
                            :rules="[rules.required('first name')]"
                            outlined
                            :disabled="true"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field
                            :label="$t('Last Name')"
                            v-model="form.lastname"
                            :rules="[rules.required('Last Name')]"
                            outlined
                            :disabled="true"
                        >
                        </v-text-field>
                    </v-flex>

                     <v-flex xs12>
                        <v-text-field
                            :label="$t('Email')"
                            v-model="form.email"
                            :rules="[rules.required('Email')]"
                            outlined
                            :disabled="true"
                        >
                        </v-text-field>
                    </v-flex>

                     <v-flex xs12>
                        <v-select
                            :label="$t('Role')"
                            v-model="form.roles"
                            :rules="[rules.required('Role')]"
                             :items="[
                                'admin',
                                'user',
                            ]"
                            outlined
                            :disabled="true"
                        ></v-select>
                    </v-flex>

                     <v-flex xs12>
                        <v-text-field
                            :label="$t('Token')"
                            v-model="form.token"
                            :rules="[rules.required('Token')]"
                            outlined
                            :disabled="true"
                        >
                        </v-text-field>
                    </v-flex>


                </v-layout>
            </v-container>
        </v-card-text>
        <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="updateUser"
                class="form-submit"
            >
                Submit
            </v-btn>
        </v-card-actions> -->
    </v-card>

</v-flex>

</v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from '../../components/status/ActiveLabel.vue';
import store from '@/store'


export default {
    mixins: [vForm],

    data(){
        return {     
            project_list: [],
            form: {
               
                id_user:null,     
                firstname: null,
                lastname: null,
                email: null,
                id_project:null,
                roles:null,
                token:null
                 
            },
            showpass: false,  
                      
          }
        },

        components: {ActiveLabel},

        created() {

            let loader = this.$loading.show();

            let token = store.getters["auth/token"];
            axios
            .get(`/api/cloud/get_firebase_project_list?token=${token}`)
            .then((res) => res.data)
            .then((res) => {
                this.project_list = res.data.result.map((item) => {
                    return {
                        project_id: item.id_project,
                        project_name: item.firebase_project_name,
                    };
                });
            })
            .catch((err) => {
                this.$toastr.e(err.response.data.message);
            })
            .finally(() => {
                loader.hide();
            });

             this.form.id_user = this.$route.params.id;
             this.getUser();
        },

        methods: {
            async updateUser(){
                let loader = this.$loading.show();
                try{
                let token = store.getters['auth/token'];
                let res = await axios.post(`/api/auth/update_firebase_user?token=${token}`,this.form)
                     if(res.status == 200){
                        this.$toastr.s('Firebase User update successfully');  
                    }
                }
                catch(err){
                    this.$toastr.e(err.response.data.message);
                }
                finally{
                    loader.hide();                  
                }
            },

            async getUser(){
                let loader = this.$loading.show();
                try{
                let token = store.getters['auth/token'];
                let res = await axios.get(`/api/auth/get_firebase_user?token=${token}`,{params:{id_user:this.form.id_user}})
                     if(res.status == 200){
                        this.form.firstname =res.data.data.result.firstname;
                        this.form.lastname =res.data.data.result.lastname;
                        this.form.email =res.data.data.result.email;
                        this.form.roles =res.data.data.result.roles;
                        this.form.id_project =res.data.data.result.id_project;
                        this.form.token =res.data.data.result.firebase_token;
                    }
                }
                catch(err){
                    this.$toastr.e(err.response.data.message);
                }
                finally{
                    loader.hide();                  
                }
            },

            
            
        }
}
</script>
<style>

.theme--light.v-text-field--outlined:not(.v-input--is-focused).v-input--is-disabled > .v-input__control > .v-input__slot fieldset {
    color: rgba(0, 0, 0, 0.36);
}

.theme--light.v-label--is-disabled {
    color: rgba(0, 0, 0, 0.6);
}



.theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
    color: rgba(0, 0, 0, 0.6);
}

.theme--light.v-select .v-select__selection--disabled {
    color: rgba(0, 0, 0, 0.6);
}
</style>